import React from 'react';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell,
} from 'recharts';

const COLORS = ['#00d9ff', '#818cf8', '#2dd4bf', '#60a5fa', '#fbbf24'];

const tooltipStyle = {
    contentStyle: {
        background: '#1e293b',
        border: '1px solid #334155',
        borderRadius: '8px',
        color: '#ffffff',
        fontSize: '13px',
        direction: 'rtl',
    },
};

export default function GovernoratesChart({ data }) {
    if (!data?.length) return <p style={{ color: '#94a3b8', textAlign: 'center', padding: '60px 0' }}>لا توجد بيانات</p>;

    return (
        <ResponsiveContainer width="100%" height={300}>
            <BarChart
                data={data}
                layout="vertical"
                margin={{ top: 4, right: 88, left: 4, bottom: 4 }}
            >
                <CartesianGrid strokeDasharray="3 3" stroke="#334155" horizontal={false} />
                <XAxis
                    type="number"
                    stroke="#94a3b8"
                    tick={{ fontSize: 12, fill: '#94a3b8' }}
                    allowDecimals={false}
                    axisLine={false}
                    tickLine={false}
                />
                <YAxis
                    dataKey="name"
                    type="category"
                    orientation="right"
                    stroke="#94a3b8"
                    tick={{ fontSize: 13, fill: '#ffffff', fontFamily: 'Almarai, sans-serif' }}
                    width={80}
                    axisLine={false}
                    tickLine={false}
                />
                <Tooltip
                    {...tooltipStyle}
                    formatter={(v) => [v, 'عدد الاحتجاجات']}
                    cursor={{ fill: 'rgba(255,255,255,0.04)' }}
                />
                <Bar dataKey="count" radius={[0, 6, 6, 0]} maxBarSize={32}>
                    {data.map((_, idx) => (
                        <Cell key={idx} fill={COLORS[idx % COLORS.length]} />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
}
